/* Общее поведение bottom sheet'ов темы: перетаскивание пальцем с инерцией,
   анимация «улёта» и закрытие по Escape.

   Escape намеренно слушается на document: раньше каждый компонент вешал
   keyup на сам диалог (или на корень секции), и клавиша переставала работать,
   стоило фокусу уйти наружу — например после клика по бэкдропу. */

(function () {
  'use strict';

  var EASE_IN = 'cubic-bezier(.4, 0, 1, 1)';
  var EASE_OUT = 'cubic-bezier(.22, .8, .3, 1)';

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clearInline(el) {
    el.style.transition = '';
    el.style.transform = '';
    el.style.opacity = '';
  }

  /* Перетаскивание вниз: панель следует за пальцем, вверх — с сопротивлением.
     Отпускание за порогом (по расстоянию или скорости) → onDismiss, иначе возврат. */
  function dragToDismiss(panel, options) {
    var opts = options || {};
    var scrollEl = opts.scrollEl || panel;
    var startY = 0;
    var delta = 0;
    var dragging = false;
    // мгновенная скорость на последнем отрезке жеста, а не средняя за весь:
    // иначе рывок в конце долгого медленного перетаскивания не засчитается
    var lastY = 0;
    var lastAt = 0;
    var velocity = 0;

    function enabled() {
      return opts.isEnabled ? opts.isEnabled() : true;
    }

    panel.addEventListener(
      'touchstart',
      function (event) {
        if (!enabled() || event.touches.length !== 1 || scrollEl.scrollTop > 0) return;
        startY = event.touches[0].clientY;
        lastY = startY;
        lastAt = Date.now();
        delta = 0;
        velocity = 0;
        dragging = true;
        panel.style.transition = 'none';
      },
      { passive: true }
    );

    panel.addEventListener(
      'touchmove',
      function (event) {
        if (!dragging) return;
        var y = event.touches[0].clientY;
        var now = Date.now();
        var dt = now - lastAt;
        if (dt > 0) {
          velocity = (y - lastY) / dt;
          lastY = y;
          lastAt = now;
        }

        var d = y - startY;
        if (d < 0) {
          d = d / 4;
        } else if (event.cancelable) {
          // тянем шит, а не страницу под ним
          event.preventDefault();
        }
        delta = d;
        panel.style.transform = 'translateY(' + d + 'px)';
        if (opts.onDrag) opts.onDrag(d);
      },
      { passive: false }
    );

    function release() {
      if (!dragging) return;
      dragging = false;
      var threshold = Math.min(140, panel.offsetHeight * 0.28);
      // отпустили далеко ИЛИ бросили вниз — улетает; иначе возвращается
      var flung = velocity > 0.6 && delta > 24;

      if (delta > threshold || flung) {
        if (opts.onDismiss) opts.onDismiss();
        return;
      }

      panel.style.transition = 'transform .26s ' + EASE_OUT;
      panel.style.transform = '';
      if (opts.onDrag) opts.onDrag(0);
    }

    panel.addEventListener('touchend', release, { passive: true });
    panel.addEventListener('touchcancel', release, { passive: true });

    return {
      reset: function () {
        dragging = false;
        clearInline(panel);
      },
    };
  }

  /* Улетание: вниз для шита, вверх с уменьшением — для desktop-поповера.
     Стартует от текущего transform, поэтому подхватывает позицию после драга. */
  function flyOut(panel, done, options) {
    var opts = options || {};
    var backdrop = opts.backdrop;

    if (reduceMotion()) {
      clearInline(panel);
      if (backdrop) backdrop.style.opacity = '';
      done();
      return;
    }

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      panel.removeEventListener('transitionend', finish);
      clearInline(panel);
      if (backdrop) {
        backdrop.style.transition = '';
        backdrop.style.opacity = '';
      }
      done();
    }

    panel.style.transition = 'transform .26s ' + EASE_IN + ', opacity .26s ease';
    panel.style.transform = opts.up ? 'translateY(-14px) scale(.985)' : 'translateY(110%)';
    panel.style.opacity = '0';

    if (backdrop) {
      backdrop.style.transition = 'opacity .26s ease';
      backdrop.style.opacity = '0';
    }

    panel.addEventListener('transitionend', finish, { once: true });
    var timer = setTimeout(finish, 320);
  }

  /* Escape на уровне документа: работает независимо от того, где фокус. */
  function onEscape(isOpen, close) {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      if (!isOpen()) return;
      close();
    });
  }

  window.DSSheet = {
    dragToDismiss: dragToDismiss,
    flyOut: flyOut,
    onEscape: onEscape,
    reduceMotion: reduceMotion,
  };
})();
